import { useSSFBehaviors, useURLParameters } from 'hooks';
import { FC, useContext, useMemo } from 'react';
import { createGQLDataContext } from 'utils/createDataContext';
import {
  CalloutListData,
  calloutListQueryConfig,
} from 'modals/ShiftModal/src/views/AuditTrailView/AuditTrailView.constants';
import { ShiftModalOrderDetailsCalloutListQuery, CalloutList } from 'types/graphql';
import { calculateEstimatedTimeRemaining } from 'modals/ShiftModal/src/views/DetailView/GeneralTab/CallOut';

export const AuditTrailDataContext = createGQLDataContext({} as CalloutListData);

export const AuditTrailDataProvider: FC = ({ children }) => {
  const [{ calloutListId }] = useURLParameters<{ calloutListId: string }>();

  const [values, useQueryOptions] = useSSFBehaviors<ShiftModalOrderDetailsCalloutListQuery>(
    calloutListQueryConfig(calloutListId),
  );

  const value = useMemo(() => {
    const nodeData = useQueryOptions?.data?.node as CalloutList;

    return {
      estimatedTimeRemaining: nodeData?.estimatedCompletedAt
        ? calculateEstimatedTimeRemaining(
            nodeData.estimatedCompletedAt,
            nodeData.order?.timeZone?.toString(),
          )
        : { mins: 0, hours: 0, days: 0 },
      values,
      ...useQueryOptions,
    };
  }, [useQueryOptions, values]);

  return <AuditTrailDataContext.Provider value={value}>{children}</AuditTrailDataContext.Provider>;
};

export const useAuditTrailDataContext = (): CalloutListData => useContext(AuditTrailDataContext);
